import { render, staticRenderFns } from "./Lock.vue?vue&type=template&id=5f41a3e2&scoped=true"
import script from "./Lock.vue?vue&type=script&lang=ts"
export * from "./Lock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f41a3e2",
  null
  
)

export default component.exports